import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { recordLoginActivity as recordLoginActivityRequest } from "../services/api";

const SESSION_LOG_KEY = "karankiActivityLogged";
let lastActiveWriteAt = 0;

function getNavigatorValue(getter, fallback = "Unknown") {
  if (typeof window === "undefined") return fallback;
  try {
    return getter() || fallback;
  } catch {
    return fallback;
  }
}

export function getDeviceInfo() {
  const userAgent = getNavigatorValue(() => window.navigator.userAgent, "");
  const platform = getNavigatorValue(() => window.navigator.platform, "Unknown platform");
  const language = getNavigatorValue(() => window.navigator.language, "Unknown language");

  let browser = "Unknown browser";
  if (/Edg/i.test(userAgent)) browser = "Edge";
  else if (/Chrome/i.test(userAgent)) browser = "Chrome";
  else if (/Safari/i.test(userAgent)) browser = "Safari";
  else if (/Firefox/i.test(userAgent)) browser = "Firefox";

  let deviceType = "Desktop";
  if (/Mobi|Android/i.test(userAgent)) deviceType = "Mobile";
  else if (/iPad|Tablet/i.test(userAgent)) deviceType = "Tablet";

  let os = "Unknown OS";
  if (/Windows/i.test(userAgent)) os = "Windows";
  else if (/Android/i.test(userAgent)) os = "Android";
  else if (/iPhone|iPad|iPod/i.test(userAgent)) os = "iOS";
  else if (/Mac/i.test(platform) || /Mac OS X/i.test(userAgent)) os = "macOS";
  else if (/Linux/i.test(platform) || /Linux/i.test(userAgent)) os = "Linux";

  const deviceName =
    deviceType === "Mobile"
      ? `${os} Mobile`
      : deviceType === "Tablet"
      ? `${os} Tablet`
      : `${browser} on ${os}`;

  return {
    browser,
    device: deviceName,
    deviceName,
    deviceType,
    language,
    os,
    platform,
    userAgent,
  };
}

export async function recordLoginSession(db, profileId, sessionStartedAt) {
  if (!profileId || !sessionStartedAt) return;

  const sessionKey = `${profileId}:${sessionStartedAt}`;
  if (sessionStorage.getItem(SESSION_LOG_KEY) === sessionKey) return;

  const deviceInfo = getDeviceInfo();
  await recordLoginActivityRequest({
    profileId,
    sessionStartedAt,
    pathname: window.location.pathname,
    deviceInfo,
  });

  sessionStorage.setItem(SESSION_LOG_KEY, sessionKey);
}

export async function updateLastActive(db, profileId, pathname, force = false, extraUpdates = {}) {
  if (!profileId) return;

  const nowMs = Date.now();
  if (!force && nowMs - lastActiveWriteAt < 30000) return;
  lastActiveWriteAt = nowMs;

  await updateDoc(doc(db, "profiles", profileId), {
    lastActiveAt: serverTimestamp(),
    lastActivePage: pathname || window.location.pathname,
    updatedAt: serverTimestamp(),
    ...extraUpdates,
  });
}
